import dayjs from 'dayjs';
import { useObservable } from 'observable-hooks';
import { defer, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

/**
 * offsetSeconds helps when the countdown end should be less than 0
 * getCountdownTimer$(Date); //emits until Date is after now
 * getCountdownTimer$(Date, 60*5); //emits until Date is after (now-5min)
 * */
export const getCountdownTimer$ = (
	endDate: Date | string,
	offsetSeconds = 0
) => {
	const endTime = dayjs(endDate).add(offsetSeconds, 's');

	return defer(() => {
		return timer(0, 1000).pipe(
			map(() => dayjs.duration(Math.max(0, endTime.diff(dayjs(), 's')), 's')),
			takeWhile((duration) => duration.asSeconds() > 0, true)
		);
	});
};

export const useCountdownTimer$ = (endDate: Date | string) => {
	return useObservable(() => getCountdownTimer$(endDate), [endDate]);
};
